import React from 'react';
import { SearchIcon, FlagIcon, ShuffleIcon, ChevronRightIcon } from 'lucide-react';
import { Section, Kicker } from './Section';
import { FlowchartCard } from './FlowchartCard';
const steps = [{
  icon: SearchIcon,
  title: 'Screen',
  body: "Ask 3 exact questions. You'll know them by heart within a week."
}, {
  icon: FlagIcon,
  title: 'Flag',
  body: 'Check the non-negotiable red flags that always mean "refer out."'
}, {
  icon: ShuffleIcon,
  title: 'Adapt',
  body: 'Swap in the right movements — mat and reformer — with the script to explain it calmly.'
}];
const outputs = [{
  color: '#2D6A4F',
  label: 'Green',
  text: 'Adapt & teach today'
}, {
  color: '#B5830A',
  label: 'Yellow',
  text: 'Conservative defaults + recommend assessment'
}, {
  color: '#9B2226',
  label: 'Red',
  text: 'Refer out — warmly, with the exact words'
}];
export function Mechanism() {
  return <Section background="white" labelledBy="mechanism-heading" data-id="element-167" data-mp="krdx64x76g5g">
      <div className="text-center" data-id="element-168" data-mp="pccanwjjkyoc">
        <Kicker data-id="element-169" data-mp="pbart5wab7w2">The mechanism</Kicker>
        <h2 id="mechanism-heading" className="mt-5 font-serif text-3xl font-semibold leading-[1.15] text-ink sm:text-[44px]" data-id="element-170" data-mp="pege6ddj3vo3">
          The Screen &amp; Adapt™ Protocol
        </h2>
        <p className="mt-4 font-sans text-[17px] text-ink-soft sm:text-lg" data-id="element-171" data-mp="bl792owm5wbd">
          Three moves. Ninety seconds. Any condition, any client, any moment.
        </p>
      </div>

      <ol className="mt-14 grid grid-cols-1 items-stretch gap-4 lg:grid-cols-[1fr_auto_1fr_auto_1fr]" data-id="element-172" data-mp="6k1fypz1k71b">
        {steps.map(({
        icon: Icon,
        title,
        body
      }, index) => <React.Fragment key={title} data-id="element-173" data-mp="3su41h7lxzcky" data-mpi={index}>
            {index > 0 && <ChevronRightIcon className="mx-auto hidden h-6 w-6 self-center text-sage/45 lg:block" strokeWidth={1.5} aria-hidden="true" data-id="element-174" data-mp="3os8yzzs9yt5l" />}
            <li className="flex h-full flex-col rounded-2xl border border-sage/15 bg-sage-soft p-6" data-id="element-175" data-mp="1n1fgb3mzpvtd">
              <div className="flex items-center gap-3" data-id="element-176" data-mp="3gi1wbfzy3fvy">
                <Icon className="h-6 w-6 text-sage" strokeWidth={1.5} aria-hidden="true" data-id="element-177" data-mp="3l9tdizx7o99f" />
                <span className="font-sans text-[11px] font-semibold uppercase tracking-[0.14em] text-brass" data-id="element-178" data-mp="3lbo2cpblslis">
                  Step {index + 1}
                </span>
              </div>
              <h3 className="mt-4 font-serif text-2xl font-semibold uppercase tracking-tight text-ink" data-id="element-179" data-mp="3bhxg7r2y8n69">
                {title}
              </h3>
              <p className="mt-3 font-sans text-[15px] leading-[1.6] text-ink-soft" data-id="element-180" data-mp="83jkd36vvg72">{body}</p>
            </li>
          </React.Fragment>)}
      </ol>

      <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-3" data-id="element-181" data-mp="3qb0plb6dzulw">
        {outputs.map(output => <li key={output.label} className="flex items-start gap-3 rounded-xl border border-sage/15 bg-white px-4 py-3.5" data-id="element-182" data-mp="3v9u14y245bjf">
            <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full" style={{
          backgroundColor: output.color
        }} aria-hidden="true" data-id="element-183" data-mp="2jtlw8pz7lo4l" />
            <p className="font-sans text-[14px] leading-snug text-ink-soft" data-id="element-184" data-mp="2796rss9klq2u">
              <span className="font-semibold uppercase tracking-[0.08em]" style={{
            color: output.color
          }} data-id="element-185" data-mp="2laj6z1gwpnno">
                {output.label}
              </span>{' '}
              — {output.text}
            </p>
          </li>)}
      </ul>

      <h3 className="mt-20 text-center font-serif text-2xl font-semibold leading-snug text-ink sm:text-3xl" data-id="element-186" data-mp="1nmits6qfj10o">
        This is the actual master flowchart from Volume 1.
      </h3>
      <FlowchartCard data-id="element-187" data-mp="22cyihvi20r3l" />
    </Section>;
}